<template>
    <div>
        <i
            class="l-ss-c-offer-like-icon"
            @click.prevent.stop="onChange()"
            :style="style"
            v-html="imageIcon">
        </i>
    </div>
</template>

<script>
    import imageIcon from '@/core/assets/images/icons/gallery.svg';
    import { IMAGE_PROXY_URL } from '/src/config.js';

    export default {
        props: {
            offer: {
                type: Object,
            },
            settings: {
                type: Object,
            },
        },

        setup(props, { emit }) {
            const { offer, settings } = props;
            const { style } = settings;

            const loadImageToBlobByUrl = (url) => {
                const paramsPart = {
                    i: url,
                };

                return fetch(`${IMAGE_PROXY_URL}?${new URLSearchParams(paramsPart).toString()}`)
                    .then(response => response.body)
                    .then(stream => new Response(stream))
                    .then(response => response.blob());
            };

            const readAsBase64 = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = function () {
                        resolve(reader.result);
                    };
                    reader.onerror = function (error) {
                        reject(error);
                    };
                    reader.readAsDataURL(file);
                });
            };

            const createBase64 = async (value) => {
                try {
                    const fileExtension = value.match(/\.[0-9a-z]+(?:\?[^\s]+)?$/i)[0].replace('.', 'image/');
                    const blob = await loadImageToBlobByUrl(value);
                    readAsBase64(blob)
                        .then(base64 => {
                            const modifyBase64String = base64.replace('application/octet-stream', fileExtension);
                            emit('similar-click-handler', false);
                            window['searchbooster'].api?.controller.handleImageSearch({ base64: modifyBase64String });
                        })
                        .catch(error => {});
                } catch (error) {
                    console.info(error);
                }
            };

            const onChange = () => {
                createBase64(offer.pictures[0]);
            };

            return {
                imageIcon,
                style,
                onChange,
            };
        },
    };
</script>

<style scoped>

</style>
